import type { ChangeEvent } from 'react'

import { Line } from '@/components/elements/Line'
import type { NewsTagProps } from '@/components/elements/News/NewsTag'
import { NewsTagButton } from '@/components/elements/News/NewsTagButton'
import { Select } from '@/components/elements/Select'
import { AccordionFilter } from '@/components/pages/News/AccordionFilter'
import { monthOptions } from '@/components/pages/News/dateOptions'
import { FilterField } from '@/components/pages/News/FilterField'

type Option = {
  value: string
  text: string
}

type Props = {
  yearOptions: readonly Option[]
  tagList: readonly NewsTagProps[]
  selectedTags: readonly string[]
  changeSelectedYear: (event: ChangeEvent<HTMLSelectElement>) => void
  changeSelectedMonth: (event: ChangeEvent<HTMLSelectElement>) => void
  changeSelectedTag: (text: string) => void
  handleAllTags: () => void
}

export const Filter = ({
  tagList,
  selectedTags,
  yearOptions,
  changeSelectedYear,
  changeSelectedMonth,
  changeSelectedTag,
  handleAllTags,
}: Props) => {
  return (
    <AccordionFilter>
      <FilterField title="Publication Date">
        <Select
          name="year"
          aria-label="掲載年"
          defaultValue=""
          options={yearOptions}
          onChange={changeSelectedYear}
        />
        <Select
          name="month"
          aria-label="掲載月"
          defaultValue=""
          options={monthOptions}
          onChange={changeSelectedMonth}
        />
      </FilterField>
      <Line color="grey" weight={1} direction="horizon" />
      <FilterField title="Tag">
        <NewsTagButton
          tag={{ name: 'ALL', code: 'all' }}
          isActive={selectedTags.length === 0}
          onClick={handleAllTags}
          disabled={selectedTags.length === 0}
        />
        {tagList.map((tag) => (
          <NewsTagButton
            tag={tag}
            key={tag.name}
            isActive={selectedTags.includes(tag.name) ?? false}
            onClick={() => changeSelectedTag(tag.name)}
          />
        ))}
      </FilterField>
    </AccordionFilter>
  )
}
